export default __webpack_public_path__ + "static/media/product-detail-related-product.0fbe3c7d.svg";